import { styled } from '@clickcease/cc-client-components-lib'

export const ThreatGroupToolTipStyled = styled('div', {
  width: '675px',
  height: '680px',
  padding: '$12',
  marginTop: '$5',
})

export const ThreatGroupTooltipsStyled = styled('div', {
  margin: '$10',
  padding: '$lg',
  fontSize: '$md',
  lineHeight: '18px',
})

export const ThreatGroupTooltipsDescription = styled('div', { marginBottom: '$10' })
export const ThreatGroupTooltipsBullets = styled('ul', {
  overflow: 'auto',
  height: '470px',

  '@bp1': {
    height: '300px',
  },
})
export const ThreatGroupTooltipsBullet = styled('li', { marginBottom: '$7' })
